export const shouldShowHttpHistoryEmptyState = ({
  filteredCount,
  isLoadingCount,
  lastPositiveCount,
}: {
  filteredCount: number | null;
  isLoadingCount: boolean;
  lastPositiveCount: number;
}): boolean =>
  !isLoadingCount && filteredCount === 0 && lastPositiveCount === 0;
